import { api } from '../client'
import type { RequestOptions } from '../client'
import type { RetrievalFilters, RetrievalRun, RetrievalSummary } from './types'

function buildQuery(f: RetrievalFilters): string {
  const params = new URLSearchParams()
  if (f.sourceId !== undefined) params.set('sourceId', String(f.sourceId))
  if (f.status) params.set('status', f.status)
  if (f.limit !== undefined) params.set('limit', String(f.limit))
  if (f.offset !== undefined) params.set('offset', String(f.offset))
  const qs = params.toString()
  return qs ? `?${qs}` : ''
}

export const retrievalsHttpApi = {
  list: (filters: RetrievalFilters = {}, options?: RequestOptions): Promise<RetrievalRun[]> =>
    api.get<RetrievalRun[]>(`/retrievals${buildQuery(filters)}`, options),
  summary: (
    filters: Omit<RetrievalFilters, 'limit' | 'offset'> = {},
    options?: RequestOptions,
  ): Promise<RetrievalSummary> =>
    api.get<RetrievalSummary>(`/retrievals/summary${buildQuery(filters)}`, options),
}
